import { useEffect, useState } from 'react';

import type { MutableRefObject } from 'react';

type UseResizeType = (ref: MutableRefObject<HTMLDivElement | null>) => {
  width: number;
  height: number;
};
export const useResize: UseResizeType = (ref) => {
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const refValue = ref.current;

    if (!refValue) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setDimensions({ width, height });
      }
    });

    if (!ref) return;

    resizeObserver.observe(refValue);

    return () => resizeObserver.unobserve(refValue);
  }, [ref]);

  return dimensions;
};
